import { CalendarInput as Calendar } from './calendar'

export default Calendar
